/**
 * 墨西哥部门银行电话
 *
 */
export const MEXBANKMESSAHE = [
  {
    NAME: 'BBVA',
    PHONE: '5556241199',
    ID: 'fin_loan_abroad_credit_clabe_bbva_ck',
  },
  {
    NAME: 'Citibanamex',
    PHONE: '5522626391',
    ID: 'fin_loan_abroad_credit_clabe_citi_ck',
  },
  {
    NAME: 'Santander',
    PHONE: '5551694300',
    ID: 'fin_loan_abroad_credit_clabe_santander_ck',
  },
  {
    NAME: 'HSBC',
    PHONE: '5557213390',
    ID: 'fin_loan_abroad_credit_clabe_hsbc_ck',
  },
  {
    NAME: 'Banorte',
    PHONE: '5551405600',
    ID: 'fin_loan_abroad_credit_clabe_banorte_ck',
  },
]

/**
 * 订单提现状态
 *
 */
export const WITHDRAW_STATUS = {
  /**
   * 成功
   */
  SUCCESS: 'S',

  /**
   * 处理中
   */
  PROGRESS: 'I',

  /**
   * 失败
   */
  FAIL: 'F',
}

/**
 * 返现渠道
 *
 */
export const CHANNEL_CODE = {
  /**
   * 滴滴信用卡
   */
  CARD: 'repayment',

  /**
   * 滴滴钱包
   */
  WALLET: 'wallet',

  /**
   * clabe
   */
  CLABE: 'clabe',
}

/**
 * 返现渠道名称
 *
 */
export const CHANNEL_DESC = {
  /**
   * 滴滴信用卡
   */
  '01': 'repayment',

  /**
   * 滴滴钱包
   */
  '02': 'wallet',

  /**
   * clabe
   */
  '03': 'clabe',
}

/**
 * 返现状态
 *
 */
export const CASH_BACK_STATUS = {
  /**
   * 可返现
   */
  AVAILABLE: '00',

  /**
   * 命中风控黑名单
   */
  BLACKLIST: '01',

  /**
   * 60天无消费
   */
  NO_CONSUMPTION: '02',

  /**
   * 逾期大于90天
   */
  OVERDUE_STAGE2: '03',

  /**
   * 逾期小于于90天
   */
  OVERDUE_STAGE1: '04',
}

/**
 * 返现逾期状态
 *
 */
export const CASH_BACK_ACCTSTATUS = {
  /**
   * 正常
   */
  NORMAL: '0',

  /**
   * 账单日逾期(大于还款日小于宽限日)
   */
  OVERDUE1: '1',

  /**
   * 宽限日逾期(大于宽限日)
   */
  OVERDUE2: '2',
}

/**
 * 返现列表展示模式
 *
 */
export const RECORD_TYPE = {
  /**
   * 正常展示
   */
  NORMAL: 'normal',

  /**
   * 查看更多
   */
  MORE: 'more',
}

/**
 * 返现列表展示模式
 *
 */
export const RECORD_STATUS = {
  /**
   * 充值成功(初始状态)
   */
  TOP_UP: 'S',

  /**
   * 已提现
   */
  WITHDRAWAL: 'W',

  /**
   * 已失效
   */
  DISABLED: 'E',
}

/**
 * 提现状态
 *
 */
export const WITHDRAW_FLAG = {
  /**
   * (负数金额)不能提现
   */
  NEGATIVE: -1,
  /**
   * 不能提现
   */
  UNABLE: 0,

  /**
   * 可以提现
   */
  ABLE: 1,

  /**
   * clabe不能提现
   */
  CLABE_UNABLE: 2,
}

/**
 * 是否可以参与返现活动
 *
 */
export const CASH_BACK_FLAG = {
  /**
   * 可以参与返现
   */
  ABLE: '1',
  /**
   * 不可以参与返现
   */
  UNABLE: '2',
}

/*
判断返现类型是不是esb
*/
export const CASH_BACK_ESB = {
  ESB: 'ESB',
}

/*
返现类型
*/
export const CASH_BACK_TYPE = {
  TRAVEL: 'travel', //出行返现
  FOOD: 'food', //外卖返现
  OTHER: 'externalMerchant', //其他返现
  TELEPHONE: 'walletTelephone', //话费充值
  GIFTCARD: 'walletGiftCard', //礼品卡
  BOLETO: 'walletBoleto', // 生活缴费
  MERCHANT: 'merchantCashback', //限时享热门商户返现
  MCC: 'mccCashback', //限制MCC时展示
  COMPLIANCE: 'otherCashback', //限制商户
}

/**
 * 返现活动
 *
 */
export const CASH_BACK_ACTITVITY = {
  /**
   * 滴滴内部返现
   */
  DIDI: '1',
  /**
   * 合作商户
   */
  MERCHANT: '2',
  /**
   * 其他限时返现
   */
  OTHER: '3',
}

/**
 * 最高返现笔数 时间周期
 *
 */
export const CASH_BACK_TIME = {
  /**
   *  0 有限次数
   */
  LIMIT: 0,
  /**
   * 1 天
   */
  DAY: 1,
  /**
   * 2 周
   */
  WEEK: 2,
  /**
   * 3 月
   */
  MONTH: 3,
  /**
   * 4 年
   */
  YEAR: 4,
  /**
   * 5 不限次数
   */
  NO_LIMIT: 5,
}

export const CASH_BACK_RAITTYPE = {
  /**
   * 固定金额
   */
  AMOUNT: '5',
  /**
   * 返现比例
   */
  PROPORTION: '6',
}

/**
 * cashback活动查询接口-查询类型枚举
 * CASHBACK_ENTRY - 返现首页活动入口查询
 * ACTIVITY_DETAIL - 活动详情页活动详情查询
 */
export enum CASH_BACK_QUERYSOURCE {
  CASHBACK_ENTRY = 'SIMPLE_ACTIVITY',
  DETAIL = 'ACTIVITY_DETAIL',
}

/**
 * cashback活动状态list
 */
export const CASH_BACK_ACT_STATUS = {
  UNACTUATED: 'UN_ACTIVATE',
  UNCOMPLETED: 'UN_COMPLETED',
  COMPETED: 'COMPETED',
}

/**
 * cashback 活动目标完成状态
 */
export enum CASH_BACK_ACT_GOAL_STATUS {
  FINISHED = 'Y',
  NOT_FINISHED = 'N',
}

// cashback 活动是否展示入口
export const CASH_BACK_ACT_OPEN_STATUS = {
  OPEN: 'Y',
  CLOSE: 'N',
}

// cashback活动报名状态列表
export const CASH_BACK_ACT_SIGN_STATUS = {
  SUCCESS: 'SUCCESS',
  EXPIRED: 'ACTIVITY_EXPIRED',
  NOT_LEGAL_USER: 'NO_PERMIT',
}

// cashback 活动过期标识
export const CASH_BACK_ACT_EXPIRE_STATUS = {
  EXPIRED: 'ACTIVITY_EXPIRED',
  NO_PERMIT: 'NO_PERMIT',
}

// cashback 活动详情按钮点击类型列表
export const CASH_BACK_ACT_BUTTON_LIST = {
  LEAVE: 'leave',
  REPAY: 'repay',
  HISTORY: 'history',
}
